<div class="okapi bg-white dark:bg-gray-900 text-black-900 dark:text-white">
    <je-application-header></je-application-header>
    <div class="sticky top-0 bg-white dark:bg-gray-900 z-100 mt-0.5">
        <je-context-header></je-context-header>
        <je-context-navigation [appContext$]="appContext$"></je-context-navigation>
    </div>
    <je-sub-header></je-sub-header>
    <main>
        <div class="2xl:w-2/3 xl:ml-32 xl:mt-16 xl:mr-32 m-8">
            <main [class.focus-highlight]="environment.enableFocusHighlight">
                <router-outlet [hidden]="isBusy"></router-outlet>
            </main>
        </div>
        @if (criticalError$ | async) {
            <je-critical-error></je-critical-error>
        }
    </main>
    <je-loading-overlay [hidden]="!isBusy"></je-loading-overlay>
    <je-ai-chatbot-dock></je-ai-chatbot-dock>
</div>
